export default __webpack_public_path__ + "static/media/wikia.5a6ecfa3.webm";